import installer from './installer'
import { config, components } from './index'

export default installer(config, components)

